import React, { useState } from 'react';
import { Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import config from '../config';
import HeaderNavbar from '../components/HeaderNavbar';
import Footer from '../components/Footer';
import Spinner from 'react-bootstrap/Spinner';
import api from '../lib/request';
import './Login.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);
    try {
      await api.post('/api/v1/auth/password-recovery', { email });
      setLoading(false);
      setMessage('If an account with that email exists, we sent instructions to reset your password. Check your email to continue the recovery process.');
      setEmail('');
      setSuccess(true);
    } catch (err) {
      setLoading(false);
      if (err && err.message) setError(err.message);
      else setError('An unexpected error occurred. Please try again later.');
    }
  };

  return (
    <>
      <HeaderNavbar />
      <div className="row">
        <div className="Auth-form-container">
          {success ? (
            <div className="Auth-form auth-account-form">
              <div className="Auth-form-content" style={{textAlign: 'center'}}>
                {message && <Alert variant="success">{message}</Alert>}
                <div className="text-center mt-2">
                  <Link to={`${config.prefixPath}/login`} className="btn btn-link">Log in</Link>
                </div>
              </div>
            </div>
          ) : (
            <form className="Auth-form auth-account-form" onSubmit={handleSubmit}>
              <div className="Auth-form-content">
                <div style={{display: 'flex', justifyContent: 'center', marginBottom: 10}}>
                  <img src="/logo.svg" alt="Logo" width="100" height="100"/>
                </div>
                <h3 className="Auth-form-title">Reset your password</h3>
                <p className="text-center mt-2">Enter your email and we'll send instructions to reset your password.</p>
                <div className="form-group mt-3">
                  <label>Email address</label>
                  <input
                    type="email"
                    className="form-control mt-1"
                    placeholder="Enter email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    autoFocus
                  />
                </div>

                {error && <Alert variant="danger" className="mt-3">{error}</Alert>}
                {message && <Alert variant="success" className="mt-3">{message}</Alert>}

                <div className="d-grid gap-2 mt-3">
                  {loading ? <Spinner animation="border" /> : <button type="submit" className="btn btn-primary">Send reset link</button>}
                </div>

              </div>
            </form>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ForgotPassword;
